module.exports = __webpack_public_path__ + "img/payname1.f43ff778.png";